<app-main-page>
  <app-recipes-list></app-recipes-list>
</app-main-page>
